import { render, staticRenderFns } from "./DisplayTrainingPathProgressLegend.vue?vue&type=template&id=d781ec76&scoped=true&"
import script from "./DisplayTrainingPathProgressLegend.vue?vue&type=script&lang=ts&"
export * from "./DisplayTrainingPathProgressLegend.vue?vue&type=script&lang=ts&"
import style0 from "./DisplayTrainingPathProgressLegend.vue?vue&type=style&index=0&id=d781ec76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d781ec76",
  null
  
)

/* custom blocks */
import block0 from "./DisplayTrainingPathProgressLegend.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
